module.exports = __webpack_public_path__ + "img/mapa-brasil.643488d3.png";